export class StatutWebsocketDto {
	estConnectee: boolean;
	heureDerniereConnexionOuDeconnexion: number;

	constructor(estConnectee: boolean, heureDerniereConnexionOuDeconnexion: number) {
		this.estConnectee = estConnectee;
		this.heureDerniereConnexionOuDeconnexion = heureDerniereConnexionOuDeconnexion;
	}
}
